export enum FinancialItemPaidStatuses {
    UNKNOWN = -1,
    UNPAID = 0,
    PAID = 1,
    PARTIALLY_PAID = 2,
    MANUALLY_PAID = 3
}
